/**
 * Split composite component exports
 *
 * Exports the Split and SplitItem components, props interfaces,
 * variant functions, and variant props types.
 */
export {
  Split,
  SplitItem,
  type SplitProps,
  type SplitItemProps,
  type SplitItemSpaceAbove,
  type SplitRatio,
} from './Split';
export {
  splitVariants,
  splitItemVariants,
  splitItemStickyVariants,
  SPLIT_RATIO_TOKENS,
  type SplitVariantProps,
  type SplitItemVariantProps,
} from './split.variants';
